(() => {
  if (window.chiclaraProductVideoLoading) return;
  window.chiclaraProductVideoLoading = true;

  const controllers = new Map();
  const mobile = window.matchMedia('(max-width: 767px)');
  const rendered = (element) => {
    if (!element) return false;
    const rect = element.getBoundingClientRect();
    const style = getComputedStyle(element);
    return rect.width > 0 && rect.height > 0 && style.display !== 'none' && style.visibility !== 'hidden';
  };
  const play = (video) => video.play()?.catch(() => {});

  function setupInline(element) {
    const video = element.querySelector('video');
    if (!video) return;
    let loaded = false;
    let active = false;
    let userPaused = false;
    let observer;
    let viewportObserver;

    const update = () => {
      const rect = element.getBoundingClientRect();
      const layoutReady = document.readyState === 'complete' || window.scrollY > 0;
      const eligible = layoutReady && mobile.matches && !document.hidden && rendered(element);
      const near = eligible && rect.top < innerHeight + 320 && rect.bottom > -320;
      const visible = eligible && rect.top < innerHeight && rect.bottom > 0;
      if (near && !loaded) {
        loaded = true;
        video.muted = true;
        if (video.dataset.poster) video.poster = video.dataset.poster;
        video.querySelectorAll('source[data-src]').forEach(source => {
          source.src = source.dataset.src;
        });
        video.preload = 'auto';
        video.load();
      }
      if (visible && loaded && !active) {
        active = true;
        if (!userPaused) play(video);
      } else if (!visible) {
        active = false;
        video.pause();
      }
    };

    video.addEventListener('pause', () => {
      if (active && !document.hidden) userPaused = true;
    });
    video.addEventListener('play', () => { userPaused = false; });
    if ('IntersectionObserver' in window) {
      observer = new IntersectionObserver(update, { rootMargin: '320px 0px', threshold: [0, 0.01, 1] });
      observer.observe(element);
      viewportObserver = new IntersectionObserver(update, { threshold: [0, 0.01, 1] });
      viewportObserver.observe(element);
    }
    controllers.set(element, { update, destroy: () => { observer?.disconnect(); viewportObserver?.disconnect(); } });
    update();
  }

  function setupBubble(element) {
    const preview = element.querySelector('.video-bubble-v2__wrapper native-video[data-chiclara-managed-video]');
    const modal = element.querySelector('.video-bubble-v2__popup');
    const popup = modal?.querySelector('native-video[data-chiclara-managed-video]');
    const states = new Map();

    const syncPlayer = (player, wanted) => {
      if (!player) return;
      const previous = states.get(player);
      states.set(player, wanted);
      if (wanted && !previous && player.hasAttribute('autoplay')) {
        player.play();
      } else if (!wanted) {
        player.pause();
      }
    };
    const update = () => {
      const visible = !document.hidden && !element.hidden && rendered(preview);
      const open = !!modal?.hasAttribute('open');
      syncPlayer(preview, visible && !open);
      syncPlayer(popup, visible && open);
    };
    const observer = new MutationObserver(update);
    observer.observe(element, { attributes: true, attributeFilter: ['hidden', 'class', 'style'] });
    if (modal) observer.observe(modal, { attributes: true, attributeFilter: ['open'] });
    controllers.set(element, {
      update,
      destroy: () => { observer.disconnect(); preview?.pause(); popup?.pause(); },
    });
    update();
  }

  function initialize(scope = document) {
    scope.querySelectorAll('[data-chiclara-inline-video]').forEach(element => {
      if (!controllers.has(element)) setupInline(element);
    });
    scope.querySelectorAll('[data-chiclara-video-bubble]').forEach(element => {
      if (!controllers.has(element)) setupBubble(element);
    });
  }

  let pending = false;
  function updateAll() {
    if (pending) return;
    pending = true;
    requestAnimationFrame(() => {
      pending = false;
      controllers.forEach((controller, element) => {
        if (!element.isConnected) {
          controller.destroy();
          controllers.delete(element);
        } else {
          controller.update();
        }
      });
    });
  }

  Promise.all([
    customElements.whenDefined('native-video'),
    customElements.whenDefined('video-bubble'),
  ]).then(() => {
    initialize();
    window.addEventListener('scroll', updateAll, { passive: true });
    window.addEventListener('resize', updateAll, { passive: true });
    window.addEventListener('load', updateAll, { once: true });
    mobile.addEventListener('change', updateAll);
    document.addEventListener('visibilitychange', () => {
      controllers.forEach(controller => controller.update());
    });
    document.addEventListener('shopify:section:load', () => initialize());
    document.addEventListener('shopify:section:unload', updateAll);
  });
})();
